/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { Helpers } from '../model';

@Pipe({
  name: 'historyFieldName',
})

export class HistoryFieldNamePipe implements PipeTransform {

  constructor() {

  }

  transform(key: string, value: string): string {
    const objField = Helpers.getHistoryFields().find(field => field.KEY === key);
    return objField ? objField.NAME : 'Change';
  }
}
